module.exports = __webpack_public_path__ + "img/hnBf.f0fbc615.png";